import classNames from 'classnames';
import clamp from 'just-clamp';
import React from 'react';
import { Typography } from '../typography/typography';
import styles from './badge.module.scss';

type Props = {
  numberToShow: number;
};

export const Badge: React.FC<Props> = ({ numberToShow }) => {
  const showPlus = numberToShow > 99;

  const clampedNumber = clamp(0, Math.round(numberToShow), 99);

  return (
    <span
      className={classNames(styles.root, {
        [styles.twoDigits]: clampedNumber > 9 && !showPlus,
        [styles.threeDigits]: showPlus,
      })}
    >
      <Typography color="white" fontStyle="bold" tag="span" variant="smalltext">
        {clampedNumber}
        {showPlus ? '+' : null}
      </Typography>
    </span>
  );
};
